<template>
    <div class="row main-content" id="top">
        <priceworkflow-sidebar
            :submission="submission"
        ></priceworkflow-sidebar>
        <div class="col-md-3" id="standard-styling" style="padding-left:50px;">
            <form @submit.prevent="saveCompany">
                <h2>ENTER COMPANY NAME:</h2>
                <company-select
                    v-if="submission.activity"
                    v-model="companySelection"
                    :activity-id="submission.activity.id"
                />
                <br />
                <br />
                <button class="btn-round-red" type="submit">NEXT STEP ></button>
            </form>
        </div>
    </div>
</template>

<script>
import Autocomplete from "vuejs-auto-complete";
export default {
    components: {
        Autocomplete
    },
    data() {
        return {
            activity: "",
            companyList: [],
            companySelection: "",
            submission: {},
        }
    },
    props: ['ppId'],
    created() {
        const ppId = typeof this.ppId === 'object' ? this.ppId.ppId || this.ppId.id : this.ppId;

        axios.get(`/api/getSubmission/${this.ppId}`)
            .then(response => {
                this.submission = response.data;

                this.activity = this.submission.activity.activity;

                if(this.submission.activity.id == '3') {
                    axios.get(`/api/getCompaniesForPriceLevelAutoComplete`).then(response => {
                        this.companyList = response.data;
                    });
                } else {
                    axios.get(`/api/getCompaniesForAutoComplete`).then(response => {
                        this.companyList = response.data;
                    });
                }
            })
            .catch(error => {
                console.error("saveCompany failed");

                if (error.response) {
                    console.error("Status:", error.response.status);
                    console.error("Response data:", error.response.data);
                } else if (error.request) {
                    console.error("No response received:", error.request);
                } else {
                    console.error("Axios error:", error.message);
                }
            }
        );
    },
    methods: {
        saveCompany() {
            const ppId = typeof this.ppId === 'object' ? this.ppId.ppId || this.ppId.id : this.ppId;

            let data = {
                id: ppId,
                custID: this.companySelection
            }
            axios.post(`/api/saveCompanyToSubmission`, data).then(response => {
                if(this.submission.activity.id == 3) {
                    this.$router.push({
                        name: "PriceWorkflowLevelDeviation",
                        params: {ppId: this.ppId}
                    });
                } else if(this.submission.activity.id == 7) {
                    this.$router.push({
                        name: "PriceWorkflowCustomDiscount",
                        params: {ppId: this.ppId}
                    });
                } else {
                    this.$router.push({
                        name: "PriceWorkflowStyleSelect",
                        params: { ppId: this.ppId }
                    });
                }
            });
        },
        selectCompany(result) {
            this.companySelection = result.value;
        }
    }
}
</script>

<style scoped>
    #standard-styling {
        font-family:'acumin-pro-condensed', Helvetica, Arial, sans-serif;
    }
</style>